"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GutterBottom = exports.LARGE = exports.MEDIUM = exports.SMALL = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SMALL = 'small';
exports.SMALL = SMALL;
var MEDIUM = 'medium';
exports.MEDIUM = MEDIUM;
var LARGE = 'large';
exports.LARGE = LARGE;

var styles = function styles(_ref) {
  var spacing = _ref.spacing;
  return {
    small: {
      '&&': {
        marginBottom: spacing(1)
      }
    },
    medium: {
      '&&': {
        marginBottom: spacing(2)
      }
    },
    large: {
      '&&': {
        marginBottom: spacing(3)
      }
    }
  };
}; // Revisit this when we can use styles hook


var GutterBottom = function GutterBottom(_ref2) {
  var _classNames;

  var classes = _ref2.classes,
      gutterBottom = _ref2.gutterBottom,
      children = _ref2.children;
  var small = classes.small,
      medium = classes.medium,
      large = classes.large;

  var child = _react.default.Children.only(children);

  var spacingClass = (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, small, gutterBottom === SMALL), _defineProperty(_classNames, medium, gutterBottom === MEDIUM), _defineProperty(_classNames, large, gutterBottom === LARGE), _classNames));
  return _react.default.cloneElement(child, {
    className: (0, _classnames.default)(child.props.className, spacingClass)
  });
};

exports.GutterBottom = GutterBottom;
process.env.NODE_ENV !== "production" ? GutterBottom.propTypes = {
  classes: _propTypes.default.object.isRequired,
  gutterBottom: _propTypes.default.oneOf([SMALL, MEDIUM, LARGE])
} : void 0;
GutterBottom.defaultProps = {
  gutterBottom: null
};

var _default = (0, _styles.withStyles)(styles, {
  name: 'GutterBottom'
})(GutterBottom);

exports.default = _default;